import request, { IWorkspaceResponse } from '../http/Xrequest '

// 分页按分类查询条例列表
export const getRegulationsPage = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/system/special-app/regulation/item/list'
  const result = await request.post(url, body)
  return result.data
}

// 获取文件关联的规章条约
export const getFileRegulations = async function (fileId: string): Promise<IWorkspaceResponse<any>> {
  const url = `/files/get-regulation-rel/${fileId}`
  const result = await request.get(url)
  return result.data
}

// 获取条例详情
export const getRegulationsMes = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `/system/special-app/regulation/item/${id}`
  const result = await request.get(url)
  return result.data
}

// 关联规章制度条约
export const getRegulationsFileRule = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/files/regulation-rel'
  const result = await request.post(url, body)
  return result.data
}

// 查询专题分类树
export const getAllSpecialTree = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/system/special-app/category/tree'
  const result = await request.get(url)
  return result.data
}

// 获取分类详情
export const getAllSpecialDetail = async function (id): Promise<IWorkspaceResponse<any>> {
  const url = `/system/special-app/category/${id}`
  const result = await request.get(url)
  return result.data
}

// 查询所有专题应用（按分类分组）
export const getAllSpecialData = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/system/special-app/list'
  const result = await request.get(url)
  return result.data
}

// 查询全部分类
export const listAllSpecialAppCategory = async function (status): Promise<IWorkspaceResponse<any>> {
  const url = '/system/special-app/category/list'
  const result = await request.get(url, { params: { status } })
  return result.data
}
